import type { TResolvedItemNames } from '@modules/items';
import type { TMap } from '@shared/types';

import type { TBlockData, TDocument } from '../types';

type TBlocksMerge = { doc: TDocument; resolvedItemNames: TResolvedItemNames };

export const newBlockIds = (doc: TDocument, blocksData: TMap<string, TBlockData> | undefined): string[] =>
  Object.keys(blocksData ?? {}).filter((id) => !(id in doc.blocksData));

export const withBlocksData = (
  doc: TDocument,
  resolvedItemNames: TResolvedItemNames,
  blocksData: TMap<string, TBlockData> | undefined,
  incomingResolvedItemNames: TResolvedItemNames | undefined
): TBlocksMerge => {
  if (newBlockIds(doc, blocksData).length === 0) return { doc, resolvedItemNames };
  return {
    doc: { ...doc, blocksData: { ...doc.blocksData, ...blocksData } },
    resolvedItemNames: { ...resolvedItemNames, ...incomingResolvedItemNames },
  };
};

// The names stay: they are keyed by item and variant folder, not by block id, so a block that stays can need the same entry.
export const withoutBlocksData = (doc: TDocument, ids: string[]): TDocument => {
  const gone = new Set(ids.filter((id) => id in doc.blocksData));
  if (gone.size === 0) return doc;
  const blocksData = { ...doc.blocksData };
  for (const id of gone) delete blocksData[id];
  return { ...doc, blocksData };
};
